export type AssetsInvalidRecordReason =
  | 'duplicate'
  | 'invalid-email'
  | 'invalid-phone';

export class AssetsInvalidRecord {
  constructor(
    public externalId: string,
    public reason: AssetsInvalidRecordReason,
    public data: Record<string, string>
  ) {}
}
